// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyLayout_wrapper__GSM85"};